module.exports = __webpack_public_path__ + "static/img/icon_money.0276e42f.png";